import { Entries, ObjectKeys } from "../types/common-types";

export const entries = <T extends object>(obj: T) => Object.entries(obj) as Entries<T>;

export const keys = Object.keys as <Type extends object>(value: Type) => Array<ObjectKeys<Type>>;

export const isEmptyObject = (obj: any) => Object.keys(obj).length === 0;
